import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { IPromoInfoSchema } from '../../types/promo';

import * as styles from './styles.css';
import { PromoItemIcon } from '../PromoItemIcon';

interface IPromoItemProps {
  onClick(): void;
  promo: IPromoInfoSchema;
}

export function PromoItem({ promo, onClick }: IPromoItemProps) {
  const { name, subtitle } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon-wrapper']}>
        <PromoItemIcon promo={promo} />
      </div>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        <div className={styles['subtitle']}>{subtitle && <UIText2 color="gray60_100">{promo.subtitle}</UIText2>}</div>
      </div>
    </div>
  );
}
